// Grid energy for one data point, split into import and export (both >= 0).
// Meters with separate registers (ME337, Acuvim II) report E_active_import / E_active_export,
// single-register meters (eGauge Core, MFM384) only report a net E_active (positive = import).
export const splitGridEnergy = (data, importKey = "E_active_import", exportKey = "E_active_export", netKey = "E_active") => {
  const _import = data[importKey];
  const _export = data[exportKey];
  if (_import != null || _export != null) {
    return { importE: _import ?? null, exportE: _export ?? null };
  }
  const _net = data[netKey];
  if (_net == null) {
    return { importE: null, exportE: null };
  }
  return { importE: Math.max(_net, 0), exportE: Math.max(-_net, 0) };
};
